module.exports = __webpack_public_path__ + "static/media/nat-3-large.417d3d74.jpg";